import React, { useEffect, useState, Fragment } from "react";
import { useLocation, Link } from "react-router-dom";
import db from "../firebase";

import styled from "@emotion/styled";

import {
  Button,
  Text,
  Image,
  Menu,
  MenuButton,
  Heading,
} from "@chakra-ui/react";
import { Spinner } from "@chakra-ui/react";
import NotFound from "../notfound.svg";

import { ChevronDownIcon } from "@chakra-ui/icons";
import SingleCard from "./SingleCard";

function Browse() {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const type = searchParams.get("type");

  const [properties, setProperties] = useState();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!type) {
      db.collection("properties").onSnapshot((snapshot) => {
        let tempProperties = snapshot.docs.map((doc) => {
          return { id: doc.id, ...doc.data() };
        });
        setProperties(tempProperties);
      });
    } else {
      db.collection("properties")
        .where("type", "==", type)
        .onSnapshot((snapshot) => {
          let tempProperties = snapshot.docs.map((doc) => {
            return { id: doc.id, ...doc.data() };
          });
          setProperties(tempProperties);
        });
    }
  }, [type]);
  return (
    <MainDiv>
      <Controllers>
        <div>
          <Link to="/browse">
            <Button color="#1A202C" variant="ghost">
              <Text fontSize="sm">All</Text>
            </Button>
          </Link>
          <Link to="/browse?type=treehouse">
            <Button color="#1A202C" variant="ghost">
              <Image src="https://a0.muscache.com/pictures/ac09b78a-19c0-46fc-b604-fc90a8912864.jpg" />
              <Text fontSize="sm">Treehouses</Text>
            </Button>
          </Link>
          <Link to="/browse?type=beachfront">
            <Button color="#1A202C" variant="ghost">
              <Image src="https://a0.muscache.com/pictures/483c0cae-5bfe-45b3-b4e4-8697253b2875.jpg" />
              <Text fontSize="sm">Beachfront</Text>
            </Button>
          </Link>
          <Link to="/browse?type=boat">
            <Button color="#1A202C" variant="ghost">
              <Image src="https://a0.muscache.com/pictures/5971ffd9-2897-4bb0-8ad6-a641690ffaba.jpg" />
              <Text fontSize="sm">Boats</Text>
            </Button>
          </Link>
          <Link to="/browse?type=tiny">
            <Button color="#1A202C" variant="ghost">
              <Image src="https://a0.muscache.com/pictures/c54d41c5-c279-442f-9ec3-afbc1c5104cb.jpg" />
              <Text fontSize="sm">Tiny homes</Text>
            </Button>
          </Link>
          <Menu>
            <MenuButton as={Button} rightIcon={<ChevronDownIcon />}>
              <Text fontSize="sm">More</Text>
            </MenuButton>
            {/* <MenuList>
              <MenuItem>
                <Image src="https://a0.muscache.com/pictures/c54d41c5-c279-442f-9ec3-afbc1c5104cb.jpg" />
                <Text fontSize="sm">Tiny homes</Text>
              </MenuItem>
              <MenuItem>
                <Image src="https://a0.muscache.com/pictures/c54d41c5-c279-442f-9ec3-afbc1c5104cb.jpg" />
                <Text fontSize="sm">Tiny homes</Text>
              </MenuItem>
              <MenuItem>
                <Image src="https://a0.muscache.com/pictures/c54d41c5-c279-442f-9ec3-afbc1c5104cb.jpg" />
                <Text fontSize="sm">Tiny homes</Text>
              </MenuItem>
            </MenuList> */}
          </Menu>
        </div>
      </Controllers>
      {!properties ? (
        <LoadingDiv>
          <Spinner color="red.500" size="xl" thickness="4px" speed="0.65s" />
        </LoadingDiv>
      ) : (
        <Fragment>
          {!properties.length > 0 && (
            <ImageDiv>
              <img src={NotFound} alt="Logo" />
              <Heading fontSize="xl" as="h2">
                Sorry, {type} properties are currently not available...
              </Heading>
            </ImageDiv>
          )}
          <CardList>
            {properties.map((p, index) => {
              if (type === p.type) {
                return (
                  <Link key={index} to={`/property/details/${p.id}`}>
                    <SingleCard property={p} />
                  </Link>
                );
              } else if (!type) {
                return (
                  <Link key={index} to={`/property/details/${p.id}`}>
                    <SingleCard property={p} />
                  </Link>
                );
              }
            })}
          </CardList>
        </Fragment>
      )}
    </MainDiv>
  );
}

export default Browse;

const MainDiv = styled.div`
  margin-top: 80px;
  padding-top: 30px;

  h2 {
    margin-top: 20px;
    margin-left: 50px;
  }
`;

const Controllers = styled.div`
  margin-left: 50px;

  @media (max-width: 1100px) {
    margin-left: 10px;
  }

  button {
    margin-left: 20px;
  }

  div {
    align-items: center;

    img {
      height: 20px;
      width: 20px;
      margin-right: 7px;
    }
  }
`;

const CardList = styled.div`
  padding: 50px 40px;
  display: grid;
  grid-template-columns: auto auto auto auto;
  justify-content: center;

  @media (max-width: 1100px) {
    display: flex;
    flex-wrap: wrap;
    padding: 50px 20px;
  }
`;
const LoadingDiv = styled.div`
  height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ImageDiv = styled.div`
  display: flex;
  padding-top: 100px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  img  {
    height: 200px;
  }
`;
